import * as S from "effect-app/Schema"

// Shared by the "Optionen Kopieren" and "Bedingungen kopieren" dialogs.

// The search over the configurators a copy can come from.
export const ConfiguratorSearchForm = S.Struct({ search: S.optional(S.NullOr(S.String)) })

// The configurators a copy can come from: every other one, narrowed by a
// case-insensitive search on the title.
export const sourceConfigurators = <C extends { readonly id: string; readonly title: string }>(
  configurators: readonly C[],
  targetId: string,
  search: string | null
): C[] => {
  const needle = (search ?? "").trim().toLowerCase()
  return configurators.filter((c) => c.id !== targetId && c.title.toLowerCase().includes(needle))
}

// The toast after copying Bedingungen: a warning when some copies point at
// options, items, groups or price tables the target lacks.
export const copiedConditionGroupsMessage = ({ copied, withMissing }: { copied: number; withMissing: number }) => {
  const what = copied === 1 ? "1 Bedingung kopiert" : `${copied} Bedingungen kopiert`
  return withMissing === 0
    ? { level: "success" as const, text: `${what}, deaktiviert.` }
    : {
      level: "warning" as const,
      text: `${what}, deaktiviert. ${withMissing} mit fehlenden Verweisen: vor dem Aktivieren prüfen.`
    }
}

// The Bedingungen picked for copying: one toggled, or all of them at once.
export const toggleSelected = <Id extends string>(selected: ReadonlySet<Id>, id: Id): Set<Id> => {
  const next = new Set(selected)
  if (!next.delete(id)) next.add(id)
  return next
}
export const toggleAllSelected = <Id extends string>(selected: ReadonlySet<Id>, ids: readonly Id[]): Set<Id> =>
  ids.every((id) => selected.has(id)) ? new Set() : new Set(ids)

// The yellow of the missing-references triangle, in the copy dialog and the list.
export const MISSING_COLOR = "amber-darken-1"

// What a row says about the references the target lacks.
export const missingReferencesText = (missing: readonly string[]) =>
  missing.length === 0 ? null : `Fehlt im Ziel: ${missing.join(", ")}`
